// extracted by mini-css-extract-plugin
export var avatar = "_kf-3";
export var avatarContainer = "_kf-2";
export var avatarSpacer = "_kf-5";
export var avatarSpacerContainer = "_kf-4";
export var avatarStackContainer = "_kf-1";
export var bubble = "_kf-0";
export var remainderBubble = "_kf-6";